import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ClipboardCheckIcon, BuildingIcon } from 'lucide-react';
const bonuses = [{
  icon: <ZapIcon className="w-5 h-5 text-accent" data-id="element-11" />,
  title: 'Banco de Actividades Dinámicas',
  subtitle: '+50 actividades interactivas listas para el aula'
}, {
  icon: <ClipboardCheckIcon className="w-5 h-5 text-accent" data-id="element-12" />,
  title: 'Evaluaciones Trimestrales',
  subtitle: 'Exámenes, TPs y rúbricas para todo el año'
}, {
  icon: <BuildingIcon className="w-5 h-5 text-accent" data-id="element-13" />,
  title: 'Simulación Empresarial',
  subtitle: 'Proyecto integrador paso a paso'
}];
export function Bonuses() {
  return <section id="bonos" className="py-10 md:py-14 bg-primary-dark relative overflow-hidden" data-id="element-14">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent to-transparent opacity-50" data-id="element-15" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-6" data-id="element-17">
          <h2 className="text-2xl md:text-3xl font-extrabold text-accent" data-id="element-18">
            🎁 3 Bonos Exclusivos GRATIS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-19">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="relative flex items-start gap-3 bg-primary/60 border border-accent/30 rounded-xl px-4 py-3.5" data-id="element-20">
              <div className="absolute top-2 right-2 bg-cta text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-21">
                GRATIS
              </div>

              <div className="bg-accent/15 w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5" data-id="element-22">
                {bonus.icon}
              </div>

              <div className="pr-12" data-id="element-23">
                <h4 className="text-sm font-bold text-white leading-tight" data-id="element-24">
                  {bonus.title}
                </h4>
                <p className="text-xs text-gray-400 mt-0.5 leading-snug" data-id="element-25">
                  {bonus.subtitle}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}